export default __webpack_public_path__ + "static/media/vision.eace197f.png";